module.exports = __webpack_public_path__ + "img/2.1b7c1e15.png";